import { Button, Spinner } from 'avo-ui'
import { GeneralData } from 'components/general-settings/beauty-profile-create/general-data/GeneralData'
import { BeautyProfileItemContainer } from '../../../containers/general-settings/beauty-profile-create/beauty-profile-item/BeautyProfileItemContainer'

export const BeautyProfileCreate = ({ sectionProps, isLoadingUpload, isLoading, isCreating, isUpdating, onSubmit }) => {
    return (
        <div className={'flex flex-col space-y-3 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex flex-col space-y-6'}>
                        <GeneralData {...sectionProps} />
                        <BeautyProfileItemContainer {...sectionProps} />
                    </div>
                    <div className={'flex py-3 justify-center'}>
                        <Button
                            className={'w-[200px]'}
                            loading={isLoadingUpload || isCreating || isUpdating}
                            title={'Submit'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
